import { Modal, Typography } from 'antd';
import { formatDollarsFromCents } from 'utilities/helpers';
import EligibilityTable from './EligibilityTable';

const getEligibilityColor = (isEligible) => {
  if (isEligible === true) {
    return 'var(--green-4)';
  }
  if (isEligible === false) {
    return 'var(--yellow-4)';
  }
  return undefined;
};

const OfferEligibilityModal = ({
  eligibilityChecks,
  eligible,
  offer,
  reAgeAmount,
  ...modalProps
}) => {
  return (
    <Modal
      {...modalProps}
      centered
      title={`${offer} Eligibility Criteria`}
      width={550}
      cancelButtonProps={{ hidden: true }}
    >
      <div style={{ marginBottom: 'var(--spacing)' }}>
        <Typography.Paragraph strong>
          Eligibility:{' '}
          <Typography.Text style={{ color: getEligibilityColor(eligible) }}>
            {eligible ? 'Eligible' : 'Ineligible'}
          </Typography.Text>
        </Typography.Paragraph>
        {eligible && reAgeAmount && (
          <Typography.Text strong>
            Remaining amount to pay: {formatDollarsFromCents(reAgeAmount)}
          </Typography.Text>
        )}
      </div>
      <EligibilityTable eligibilityChecks={eligibilityChecks} />
    </Modal>
  );
};

export default OfferEligibilityModal;
